import { RestClient } from "./restClient";

export class SharingConnectionService {
	constructor(options) {
		this._options = options;
		this._restClient = new RestClient();
	}

	/**
	 * Check to see if sharing tokens are enabled in the ecosystem config
	 * @param {function} callback
	 */
	sharingTokensEnabled(callback) {
		const url = "/ecosystem/api/sharingConnection/status";
		this._restClient.exec_get(url, callback);
	}

	/**
	 * Create a sharing connection
	 * @param {function} callback
	 */
	createConnection(callback) {
		const url = "/ecosystem/api/organizations/sharingConnection";
		this._restClient.exec_post(url, null, callback);
	}

	/**
	 * Add an org as the target of a connection
	 * @param {string} connectionId
	 * @param {function} callback
	 */
	establishConnection(connectionId, callback) {
		const url = `/ecosystem/api/organizations/sharingConnection/${connectionId}`;
		this._restClient.exec_put(url, null, callback);
	}

	/**
	 * Remove a connection
	 * @param {string} connectionId
	 * @param {function} callback
	 */
	disconnectConnection(connectionId, callback) {
		const url = `/ecosystem/api/organizations/sharingConnection/${connectionId}`;
		this._restClient.exec_delete(url, callback);
	}

	/**
	 * Bulk Save sharing connections
	 * @param {object} data
	 * @param {function} callback
	 */
	bulkSaveSharingConn(data, callback) {
		const body = JSON.stringify(data);
		const url = "/ecosystem/api/organizations/bulkSave/sharingConnection";
		this._restClient.exec_post(url, body, callback);
	}

	/**
	 * Test sharing connection
	 */
	testSharingConnection(connectionId, callback) {
		const url = `/ecosystem/api/organizations/testConnection/${connectionId}`;
		this._restClient.exec_get(url, callback);
	}
}
